import defaultReducers from '@src/models/defaultReducers'
import { HealthMetricCollection, LabResultCollection } from '@src/types'
import commonReducers from '@src/models/commonReducers'
import { LabResultsStoreState } from './labResults.types'

export const reducers = {
  ...defaultReducers,
  updateListItem: commonReducers.updateListItem,
  updateHealthMetrics: (
    state: LabResultsStoreState,
    { payload }: { payload: HealthMetricCollection },
  ) => {
    return {
      ...state,
      healthMetrics: payload,
    }
  },
  updateLabResults: (
    state: LabResultsStoreState,
    { payload }: { payload: LabResultCollection },
  ) => {
    return {
      ...state,
      labResults: payload,
    }
  },
}

export default reducers
